import GpanelOrganizationDirectoryGrid from './gpanel-organization-directory-grid';

export default function GpanelOrganizationDirectoryGridPage() {
  return <GpanelOrganizationDirectoryGrid />;
}
